// extracted by mini-css-extract-plugin
export var currencyInput = "_la-1";
export var currencySymbol = "_la-0";